export { StatusBarModule } from "./statusBarModule";
